import type {
  ComponentProps,
  ComponentState,
  Slot,
  Button,
  MenuTrigger,
  MenuPopover,
  MenuList,
  TabListProps,
} from '@fluentui/react-components';

export type GroundingCommandBarOverflowMenuSlots = {
  root: NonNullable<Slot<'span'>>;
  menuTrigger?: Slot<typeof MenuTrigger>;
  menuButton?: Slot<typeof Button>;
  menuPopover?: Slot<typeof MenuPopover>;
  menuList?: Slot<typeof MenuList>;
};

/**
 * GroundingCommandBarOverflowMenu Props
 */
export type GroundingCommandBarOverflowMenuProps = ComponentProps<GroundingCommandBarOverflowMenuSlots> & {
  onTabSelect?: TabListProps['onTabSelect'];
  /**
   * String to be used as the label of the overflowButtonLabel.
   * If undefined, or the provided function returns undefined, the default label will be used.
   * By default, if all tabs are overflowing, the label will be taken from the selected tab. Otherwise, the default label is '{x} more'
   * Return undefined when overflowCount is equal to the number of tabs to preserve this labelling behavior.
   */
  overflowButtonLabel?: (overflowCount: number) => string | undefined;
};

/**
 * State used in rendering GroundingCommandBarOverflowMenu
 */
export type GroundingCommandBarOverflowMenuState = ComponentState<GroundingCommandBarOverflowMenuSlots> & {
  isOverflowing: boolean;
};
